var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / weather_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "64.2513067%",
    x2: "50%",
    y2: "36.7469666%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-weather_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weather",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sun---Fill",
    fill: "#E2B236"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    fillRule: "nonzero",
    cx: 28,
    cy: 28,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    transform: "translate(11.736544, 44.263456) rotate(-315.000000) translate(-11.736544, -44.263456) ",
    x: 9.73654403,
    y: 39.263456,
    width: 4,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    transform: "translate(44.263456, 11.736544) rotate(-315.000000) translate(-44.263456, -11.736544) ",
    x: 42.263456,
    y: 6.73654403,
    width: 4,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    transform: "translate(11.736544, 11.736544) rotate(-225.000000) translate(-11.736544, -11.736544) ",
    x: 9.73654403,
    y: 6.73654403,
    width: 4,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    x: 26,
    y: 46,
    width: 4,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    x: 26,
    y: 0,
    width: 4,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    transform: "translate(51.000000, 28.000000) rotate(-270.000000) translate(-51.000000, -28.000000) ",
    x: 49,
    y: 23,
    width: 4,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ray",
    transform: "translate(5.000000, 28.000000) rotate(-270.000000) translate(-5.000000, -28.000000) ",
    x: 3,
    y: 23,
    width: 4,
    height: 10,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78,63.96875 C80.1875,63.96875 82.0625,63.1875 83.625,61.625 C85.1875,60.0625 85.96875,58.1875 85.96875,56 C85.96875,54.75 85.703125,53.59375 85.171875,52.53125 C84.640625,51.46875 83.9375,50.5625 83.0625,49.8125 C83.375,49.0625 83.609375,48.28125 83.765625,47.46875 C83.921875,46.65625 84,45.84375 84,45.03125 C84,41.40625 82.734375,38.328125 80.203125,35.796875 C77.671875,33.265625 74.59375,32 70.96875,32 C68.15625,32 65.640625,32.8125 63.421875,34.4375 C61.203125,36.0625 59.65625,38.125 58.78125,40.625 C57.84375,39.8125 56.8125,39.171875 55.6875,38.703125 C54.5625,38.234375 53.34375,38 52.03125,38 C49.21875,38 46.84375,38.96875 44.90625,40.90625 C42.96875,42.84375 42,45.21875 42,48.03125 L42,48.03125 L42,48.3125 C40.3125,48.75 38.890625,49.671875 37.734375,51.078125 C36.578125,52.484375 36,54.125 36,56 C36,58.1875 36.78125,60.0625 38.34375,61.625 C39.90625,63.1875 41.78125,63.96875 43.96875,63.96875 L43.96875,63.96875 L78,63.96875 Z",
    id: "Cloud---Fill",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.96875,33 C74.3155725,33 77.1585944,34.166558 79.4960182,36.5039818 C81.833442,38.8414056 83,41.6844275 83,45.03125 C83,45.7808112 82.927763,46.5303517 82.7836186,47.2799026 C82.6404247,48.0245108 82.4258159,48.740542 82.1394231,49.4278846 C82.0423565,49.6608444 81.9371435,49.8902696 81.8238666,50.116218 C82.0265996,50.2577876 82.2225529,50.4096231 82.4117086,50.5717566 C83.1861032,51.2355234 83.8073552,52.0382784 84.2774478,52.9784636 C84.7402056,53.9039793 84.96875,54.9116162 84.96875,56 C84.96875,57.9129902 84.2839747,59.5518118 82.9178932,60.9178932 C81.5518118,62.2839747 79.9129902,62.96875 78,62.96875 L78,62.96875 L43.9859926,62.96875 C41.9077652,62.8953894 40.3539871,62.2210236 39.0508568,60.9178932 C37.6847753,59.5518118 37,57.9129902 37,56 C37,54.3678618 37.4997498,52.9380217 38.5068005,51.7132304 C39.5220143,50.4785109 40.7683564,49.6648762 42.2509622,49.2804969 C42.5005365,49.2157924 42.7501692,49.1649722 42.999749,49.1275276 C42.9929283,48.8711798 42.9929139,48.6079857 42.9996866,48.3375342 C43.0743088,45.3576565 43.9277387,43.2989748 45.6133568,41.6133568 C47.3585734,39.8681402 49.4991238,39 52.03125,39 C53.2052732,39 54.2962278,39.2067616 55.3028846,39.6262019 C56.3296978,40.0540408 57.2706795,40.6391344 58.1263195,41.3806891 C58.5475592,41.7457635 58.9342026,42.136702 59.2862416,42.55345 C59.3937067,42.0170318 59.5399653,41.4843307 59.7251084,40.9553504 C60.533149,38.646663 61.964402,36.7444617 64.0127459,35.2442661 C66.0577823,33.746493 68.3769787,33 70.96875,33 Z",
    id: "Cloud---Border",
    stroke: "#F2F0F0",
    strokeWidth: 2,
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherAppTile);
export default __webpack_public_path__ + "static/media/weather_app_tile.7d5c146b080edf5a44575819984dc2ec.svg";
export { ForwardRef as ReactComponent };